import styled from 'styled-components'

export default styled.div<{ color: string }>`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: 100%; */
  /* height: 100vh; */
  width: 100%;
  height: 100%;
  min-height: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: hidden;

  z-index: 1;
  ${({ color }) => `background: ${color};`};
  -ms-overflow-style: none; // IE 10+
  scrollbar-width: none; // Firefox
  &::-webkit-scrollbar {
    display: none; // Safari and Chrome
  }
  & > div ::-webkit-scrollbar {
    display: none;
  }
`
